import { configureStore, combineReducers } from "@reduxjs/toolkit";
import edgesReducer from "./edgesSlice";
import nodeReducer from "./nodesSlice";
import edgepositionedReducer from "./edgesPositionedSlice";
import nodepositionedReducer from "./nodePositionedSlice";
import adminSlice from "./adminSlice";
import usersSlice from "./usersSlice";
import groupsslice from "./businessSlice";
import selectedNodesSlice from "./selectedNodesSlice";
import websoketSlice from "./websocketSlice";
import socketMiddleware from "./socket/socketMiddleware";
import { organizationApi } from "./organizationApi";

// Combine all reducers including the API reducer
const rootReducer = combineReducers({
  edges: edgesReducer,
  nodes: nodeReducer,
  edgepositioned: edgepositionedReducer,
  nodepositioned: nodepositionedReducer,
  admin: adminSlice,
  user: usersSlice,
  groups: groupsslice,
  selectedNodes: selectedNodesSlice,
  websocket: websoketSlice,
  [organizationApi.reducerPath]: organizationApi.reducer,
});

const customizedStore = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(socketMiddleware)
      .concat(organizationApi.middleware),
});

export const store = customizedStore;
